<template>
    <v-menu
    :close-on-content-click="false"
    offset-y>
      <template v-slot:activator="{ on, attrs }">


        <v-avatar
          v-bind="attrs"
          v-on="on"
          color="primary"
          size="35"
        >
          <img
            v-if="user.photoURL"
            :src="user.photoURL"
            :alt="user.name"
          >
          <span
          v-else>
            {{ (user.name || user.email).substring(0,2).toUpperCase() }}
          </span>
        </v-avatar>
      </template>
      <v-card
        class="mx-auto"
        width="350"
        outlined
      >
 
        <organisaition />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="logout" text>Logout</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
</template>

<script>
import {get,sync} from 'vuex-pathify'
import login from './login.vue'
import organisaition from './organisation/organisaition.vue'

  export default {
    components: {
      login,
      organisaition,
    },
    data: () => ({

    }),
    computed: {
      user: get("user"),
    },
    methods: {
      logout() {
        this.$store.dispatch("logOut")
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>